import { render, staticRenderFns } from "./flag-user.html?vue&type=template&id=0a998810&scoped=true&"
import script from "./flag-user.js?vue&type=script&lang=js&"
export * from "./flag-user.js?vue&type=script&lang=js&"
import style0 from "./flag-user.scss?vue&type=style&index=0&id=0a998810&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a998810",
  null
  
)

export default component.exports